import { Menu, MenuItem, SxProps, Theme } from '@mui/material'
import React, { useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { CaslCanNotHide } from '@/contexts/CaslProvider'
import { Button } from '@/@core/components/mui/Button'
import { CompanyStatusEnum, useBranchStatusColors, useCompanyStatusOptions } from '@/@data'

interface EmployerStatusDropDownProps {
  status: CompanyStatusEnum
  onSelect?: (status: CompanyStatusEnum) => void
  disabled?: boolean
  className?: string
  fullWidth?: boolean
  sx?: SxProps<Theme>
  isDetail?: boolean
}

export const EmployerStatusDropDown = ({
  status,
  onSelect,
  fullWidth,
  disabled = false,
  className = '',
  sx,
  isDetail = false
}: EmployerStatusDropDownProps) => {
  const statusOptions = useCompanyStatusOptions()
  const statusColors = useBranchStatusColors()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isDetail) return
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (selectedStatus: CompanyStatusEnum) => {
    onSelect?.(selectedStatus)
    handleClose()
  }

  const selectedOption = statusOptions.find(option => option.value === status)

  return (
    <CaslCanNotHide action='put' subject='employer_list'>
      {(allowed: boolean) => (
        <>
          <Button
            onClick={allowed ? handleClick : undefined}
            disabled={disabled}
            className={className}
            endIcon={allowed && !isDetail ? <KeyboardArrowDownIcon /> : null}
            variant='tonal'
            fullWidth={fullWidth}
            color={selectedOption ? statusColors[selectedOption.value] : undefined}
            sx={sx}
          >
            <span className='font-medium'>{selectedOption?.label}</span>
          </Button>

          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            {statusOptions.map(option => (
              <MenuItem
                key={option.value}
                onClick={() => handleSelect(option.value)}
                sx={{ color: `${statusColors[option.value]}.main` }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </CaslCanNotHide>
  )
}
